import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import BlockchainDashboard from './components/dashboard/BlockchainDashboard';
import NetworkSpecs from './components/specs/NetworkSpecs';
import NodesMapSection from './components/nodes/NodesMapSection';
import MasternodesSection from './components/masternodes/MasternodesSection';
import DevFundSection from './components/devfund/DevFundSection';
import WalletDownloads from './components/wallets/WalletDownloads';
import Footer from './components/Footer';
import ApiDocs from './pages/ApiDocs';
import Privacy from './pages/Privacy';
import Whitepaper from './pages/Whitepaper';
import Terms from './pages/Terms';
import { NetworkProvider } from './contexts/NetworkContext';
import { ReleaseProvider } from './contexts/ReleaseContext';
import ScrollToTop from './components/ScrollToTop';

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <NetworkProvider>
        <ReleaseProvider>
          <Routes>
            <Route path="/api" element={<ApiDocs />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/whitepaper" element={<Whitepaper />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/" element={
              <div className="min-h-screen bg-gradient-to-b from-slate-900 to-slate-800 text-white">
                <Header />
                <Hero />
                <BlockchainDashboard />
                <NodesMapSection />
                <NetworkSpecs />
                <MasternodesSection />
                <DevFundSection />
                <WalletDownloads />
                <Footer />
              </div>
            } />
          </Routes>
        </ReleaseProvider>
      </NetworkProvider>
    </BrowserRouter>
  );
}